const tableStatusColors = {
  ready: "success",
  busy: "danger"
}

export default tableStatusColors